import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    HomeOutlined,
    GroupOutlined,
    CheckCircleOutline,
    WarningAmberOutlined,
    PersonSearchOutlined,
    CompareArrowsOutlined,
    InfoOutlined
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    はじめに
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('definition')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアとシェアハウスの定義と違い
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('proscons')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    メリット・デメリット徹底比較
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('fit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    どんな人に向いている？タイプ別診断
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('lifeComparison')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際の生活を比較！ルームシェアvsシェアハウス
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('advice')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめと選び方のアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    はじめに
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    <b>「ルームシェア」と「シェアハウス」、似ているようで実は大きく違うこの2つの住まい方。</b>
                    住居費の節約、出会いのチャンス、そして新しいライフスタイル――。近年、20代から30代を中心に人気が高まっていますが、「どちらを選ぶべき？」と迷っている方も多いはずです。
                </Typography>
                <Typography variant="body1" paragraph>
                    本記事では、<Chip label="ルームシェア" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />と
                    <Chip label="シェアハウス" color="primary" variant="outlined" size="small" />の
                    <b>定義の違い</b>から、<b>メリット・デメリット</b>、<b>向いている人のタイプ</b>、<b>リアルな生活の違い</b>まで、徹底的に比較して解説します。
                </Typography>
                <Typography variant="body1" paragraph>
                    どちらが自分に合っているのか、この記事を読めばきっと答えが見つかります。<b>後悔しない住まい選び</b>のために、ぜひ最後までご覧ください。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/living-dining-share_roomshare-vs-sharehouse.jpg"
                        alt="明るい共有リビングで多様なルームメイトたちが笑顔で食事を楽しみながら交流している、温かみのある雰囲気の写真。"
                        style={{ width: "100%", borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.05)', marginTop: 8 }}
                    />
                    <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#888" }}>
                        共同生活のリアルな雰囲気を感じられる、明るい共有リビングの一コマ
                    </Typography>
                </Box>
            </Box>

            {/* 定義と違い */}
            <Box id="definition" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアとシェアハウスの定義と違い
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <HomeOutlined sx={{ mr: 1, color: 'primary.main' }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>ルームシェア</Typography>
                            </Box>
                            <Typography variant="body2" paragraph>
                                <b>友人や知人同士で一つの賃貸物件を契約し、一緒に暮らす住まい方。</b>家賃や光熱費は住人同士で分担し、契約者もシェアメイト全員または代表者となるケースが多いです。<br />
                                <b>住人の構成やルールも自分たちで決める</b>ため、自由度が高いのが特徴です。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><GroupOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="主に知人・友人同士でスタート" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><PersonSearchOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="住人選び・ルール作りも自分たち次第" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><HomeOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="賃貸契約は住人または代表者が管理" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <GroupOutlined sx={{ mr: 1, color: 'secondary.main' }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>シェアハウス</Typography>
                            </Box>
                            <Typography variant="body2" paragraph>
                                <b>運営会社や大家が用意した物件に、見ず知らずの複数人が個室を借りて住むスタイル。</b>
                                共用部（キッチン・リビング・バス等）は共同で使い、<b>入居・退去管理やルール設定は運営側が行う</b>のが基本です。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><HomeOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText primary="個室＋共有スペース" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText primary="運営会社による管理・ルール" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><GroupOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText primary="多様なバックグラウンドの住人" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" paragraph>
                        <b>要点まとめ：</b>
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CompareArrowsOutlined color="action" /></ListItemIcon>
                            <ListItemText
                                primary={
                                    <span>
                                        <b>契約者・管理者：</b> ルームシェアは住人自身／シェアハウスは運営会社や大家
                                    </span>
                                }
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CompareArrowsOutlined color="action" /></ListItemIcon>
                            <ListItemText
                                primary={
                                    <span>
                                        <b>住人の選び方：</b> ルームシェアは自分で選択／シェアハウスは募集・マッチング制
                                    </span>
                                }
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CompareArrowsOutlined color="action" /></ListItemIcon>
                            <ListItemText
                                primary={
                                    <span>
                                        <b>ルールの決め方：</b> ルームシェアは話し合い／シェアハウスは運営側が主導
                                    </span>
                                }
                            />
                        </ListItem>
                    </List>
                </Box>
            </Box>

            {/* メリット・デメリット比較 */}
            <Box id="proscons" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    メリット・デメリット徹底比較
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'primary.main' }}>
                                ルームシェアのメリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="家賃・光熱費の大幅な節約が可能"
                                        secondary="都心の広め物件も分担でリーズナブル"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="住人や生活ルールは自分たちで決められる"
                                        secondary="気の合う仲間と快適な環境づくり"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="自由度の高い生活ができる"
                                        secondary="イベントや模様替えも相談しやすい"
                                    />
                                </ListItem>
                            </List>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'error.main' }}>
                                ルームシェアのデメリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="トラブル時の対処や契約管理も自分たち"
                                        secondary="家賃未払い、生活習慣の違いに注意"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="プライベートな空間が限られる"
                                        secondary="個室の確保には工夫が必要"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="退去時のトラブルが起こりやすい"
                                        secondary="敷金・礼金の分担や解約時の負担"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'secondary.main' }}>
                                シェアハウスのメリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="初対面でも安心の管理体制"
                                        secondary="トラブル時は運営会社がサポート"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="多様な人と交流できる"
                                        secondary="国際交流や価値観の広がり"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="短期間の入居も可能"
                                        secondary="敷金・礼金不要物件も多い"
                                    />
                                </ListItem>
                            </List>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'error.main' }}>
                                シェアハウスのデメリット
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="住人の入れ替わりが多い"
                                        secondary="人間関係の変化に注意"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="ルールが細かく自由度は低め"
                                        secondary="規則やイベント等、合わない場合も"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><WarningAmberOutlined color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="防音・プライバシー面で課題も"
                                        secondary="壁が薄い場合や共用部の騒音"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/roommates-rules-board_roomshare-vs-sharehouse.jpg"
                        alt="共有リビングの壁に手書きのルールボードが掲示され、住人同士がルールを確認し合う場面。明るく開放的な雰囲気で、シェア生活の工夫が感じられる写真。"
                        style={{ width: "100%", borderRadius: 8, marginTop: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.05)' }}
                    />
                    <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#888" }}>
                        ルールや分担を明確にすることで、共同生活のトラブルも回避しやすくなる
                    </Typography>
                </Box>
            </Box>

            {/* 向いている人 */}
            <Box id="fit" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    どんな人に向いている？タイプ別診断
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ borderLeft: '5px solid #1976d2', borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
                                    <HomeOutlined sx={{ mr: 1 }} />ルームシェアが向いている人
                                </Typography>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                        <ListItemText
                                            primary="気心の知れた友人・仲間と暮らしたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                        <ListItemText
                                            primary="自分たちでルールや空間を自由にアレンジしたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                        <ListItemText
                                            primary="コストを最大限抑えたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                        <ListItemText
                                            primary="住民同士で助け合いながら生活したい"
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ borderLeft: '5px solid #9c27b0', borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: 'secondary.main', mb: 1 }}>
                                    <GroupOutlined sx={{ mr: 1 }} />シェアハウスが向いている人
                                </Typography>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                        <ListItemText
                                            primary="新しい人間関係や価値観に触れたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                        <ListItemText
                                            primary="初めての共同生活で手軽に始めたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                        <ListItemText
                                            primary="管理やトラブル対応をプロに任せたい"
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutline color="secondary" /></ListItemIcon>
                                        <ListItemText
                                            primary="短期間の滞在や引越しを検討している"
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <Typography variant="body2">
                        <b>どちらも一長一短。自分に合った暮らし方を想像して選ぶことが大切です。</b>
                    </Typography>
                </Box>
            </Box>

            {/* 実際の生活比較 */}
            <Box id="lifeComparison" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際の生活を比較！ルームシェアvsシェアハウス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
                                ルームシェアのリアル
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="掃除やゴミ出しは当番制？自主管理が多め"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="家族的な距離感で助け合える"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="トラブル時は話し合いで解決"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="プライベートは部屋やカーテンで工夫"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'secondary.main', mb: 1 }}>
                                シェアハウスのリアル
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="共用部の清掃は業者または運営が実施"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="住人同士の距離感はほどほど"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="イベントや交流会が定期的に開催"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="secondary" /></ListItemIcon>
                                    <ListItemText
                                        primary="個室のプライベート空間が確保"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    
                    <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#888" }}>
                        多様な人々と交流できるシェアハウスのイベントは、新しい発見や友人づくりのきっかけにも
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" paragraph>
                        <b>専門家の一言：</b><br />
                        「人付き合いの濃さ」や「管理の手間」、「どこまでプライベートを大事にしたいか」が選び方の大きなポイント。<br />
                        ルームシェアは絆重視、シェアハウスは多様性と手軽さ重視の傾向があります。
                    </Typography>
                </Box>
            </Box>

            {/* まとめと選び方アドバイス */}
            <Box id="advice" sx={{ mb: 8 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめと選び方のアドバイス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={3} sx={{ p: 3, borderRadius: 3, bgcolor: '#f5faff' }}>
                    <Typography variant="h6" sx={{ mb: 1, color: 'primary.main' }}>
                        選び方のポイント
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="どんな人と、どんな距離感で暮らしたいかを明確にしよう"
                                secondary="友人との絆重視ならルームシェア／新しい出会い重視ならシェアハウス"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="トラブル時の対応力や管理の手間も考慮"
                                secondary="自分たちで解決できるか？運営に任せたいか？"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="費用・入居期間・プライバシーの優先度を整理"
                                secondary="短期重視・初期費用を抑えたい人はシェアハウスも◎"
                            />
                        </ListItem>
                    </List>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        どちらも暮らしの幅が広がる素晴らしい選択肢です。自分のライフスタイルや価値観にあった住まい方を、ぜひじっくりと考えてみてください。
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#1976d2' }}>
                        迷ったときは、<b>見学や体験入居</b>もおすすめです！
                    </Typography>
                </Paper>
                <Box sx={{ mt: 4 }}>
                    <img
                        src="/images/blog/sharehouse-entrance_roomshare-vs-sharehouse.jpg"
                        alt="モダンなシェアハウスのエントランスで、数名の住人が笑顔で挨拶を交わしながら出入りしている場面。明るく清潔感のある外観と安心感が伝わる写真。"
                        style={{ width: "100%", borderRadius: 8, marginTop: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.05)' }}
                    />
                    <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#888" }}>
                        シェアハウスのエントランスは、人と人をつなげる日常の出会いの場所
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-vs-sharehouse',
    slug: 'roomshare-vs-sharehouse',
    title: 'ルームシェアとシェアハウスの違いを徹底解説！自分に合う住まいの選び方',
    excerpt: '定義の違い メリット・デメリット 向いている人 実際の生活比較',
    coverImage: '/images/blog/cover-roomshare-vs-sharehouse_roomshare-vs-sharehouse.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。木目調の家具やカラフルなインテリアが並び、リラックスした雰囲気と共同生活の魅力が伝わる空間。',
    publishedAt: '2024-06-10T09:00:00+09:00',
    isPublished: true,
    categories: ['住まい', 'シェアハウス', 'ライフスタイル'],
    tags: ['ルームシェア', 'シェアハウス', '共同生活'],
    author: {
        name: '高橋 俊介',
        avatar: '/images/avatars/takahashi.jpg',
        bio: '住宅業界で10年以上の経験を持ち、ルームシェアやシェアハウスの運営・仲介に携わる。多様な共同生活の事例に精通し、初心者にもわかりやすいアドバイスを心掛けている。',
        profilePicture: '/images/avatars/takahashi.jpg'
    },
    viewCount: 1045,
    contentComponent: PostContent
};

export default post;